import { render, staticRenderFns } from "./label_details.vue?vue&type=template&id=a3ba6e64&scoped=true&"
import script from "./label_details.vue?vue&type=script&lang=js&"
export * from "./label_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ba6e64",
  null
  
)

export default component.exports